import * as THREE from 'three';
const DEG2RAD = Math.PI / 180;
/**
 * Removes emissive glow from materials so the object doesn't act as a light source.
 */
function stripEmissiveFromGroup(group) {
    group.traverse((child) => {
        if (!(child instanceof THREE.Mesh) || !child.material)
            return;
        const materials = Array.isArray(child.material) ? child.material : [child.material];
        materials.forEach((m) => {
            const mat = m;
            if (mat.emissive) {
                mat.emissive.set(0x000000);
                if (mat.emissiveIntensity !== undefined)
                    mat.emissiveIntensity = 0;
            }
        });
    });
}
/**
 * Applies position, rotation (degrees -> radians), and scale from config to a loaded GLTF scene and adds it to the Three scene.
 * Keeps the GLB's embedded materials (no texture override).
 * If config has stripEmissive: true, removes emissive from materials so the object doesn't emit light.
 */
export function placeModelInScene(scene, gltf, config) {
    const group = gltf.scene;
    group.position.set(config.position[0], config.position[1], config.position[2]);
    group.rotation.set(config.rotation[0] * DEG2RAD, config.rotation[1] * DEG2RAD, config.rotation[2] * DEG2RAD);
    const scale = config.scale;
    if (typeof scale === 'number') {
        group.scale.setScalar(scale);
    }
    else {
        group.scale.set(scale[0], scale[1], scale[2]);
    }
    if (config.stripEmissive) {
        stripEmissiveFromGroup(group);
    }
    scene.add(group);
}
